import { skipToken } from '@reduxjs/toolkit/query'
import {
  MeetingQueryStatusEnum,
  MeetingsSortColumnEnum,
  useGetBoardperiodsQuery,
  usePostMeetingsListQuery,
} from 'api/boardmeetings'
import type { PostMeetingsListApiArg } from 'api/boardmeetings'
import { useAppSelector } from 'appHooks'
import { DEFAULT_PAGE_TAKE } from 'shared/constants/filters'
import { ISortOrderEnum } from 'shared/models/List'
import { getActiveClientId } from 'shared/store/clients/selectors'

export type MeetingsListFilters = {
  queryStatus: MeetingQueryStatusEnum
  sortColumn: MeetingsSortColumnEnum
  sortOrder: string
  searchText: string
  to?: Date
  from?: Date
  take: number
  skip: number
}

export const meetingsListInitialFilters: MeetingsListFilters = {
  queryStatus: MeetingQueryStatusEnum.Active,
  sortColumn: MeetingsSortColumnEnum.Time,
  sortOrder: ISortOrderEnum.desc,
  searchText: '',
  to: undefined,
  from: undefined,
  take: DEFAULT_PAGE_TAKE,
  skip: 0,
}

export const useMeetingsList = (filters: MeetingsListFilters) => {
  const clientId = useAppSelector(getActiveClientId)

  const { data, isFetching, isError } = usePostMeetingsListQuery(
    clientId
      ? ({
          meetingsQueryModel: { ...filters, clientId },
        } as unknown as PostMeetingsListApiArg)
      : skipToken
  )

  return { data, loading: isFetching, error: isError }
}

export const useMeetingPeriods = (skip: boolean) => {
  const { data, isFetching, isError } = useGetBoardperiodsQuery(
    skip ? skipToken : {}
  )

  return { data, loading: isFetching, error: isError }
}
